export default __webpack_public_path__ + "static/media/Dine-In.ae79cdee.svg";